// extracted by mini-css-extract-plugin
export var image = "bh_H";